import CameraIcon from './CameraIcon';
export default CameraIcon;
